import { z } from "zod";

export const FormSchema = z.object({
  name: z.string().min(1, "This field is required."),
  description: z.string().optional(),
});
export type FormType = z.infer<typeof FormSchema>;
